export default "__VITE_ASSET__qsrQSpae__"